import ReactDOM from 'react-dom';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import VButton from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';

// import e from '../style.module.css';
import apiService from 'Services/apiService';
import AlertNotification, {IAlert} from "components/common/AlertNotification/AlertNotification";
import { DownloadDOC } from 'Utils/Fn/DownloadDOC';
import { formatDate } from 'Utils/Fn/DateParser';
// import './style.css'

function ModalGenerateReport({ show, mData, handleClose }: IModal) {

  const [alert, setAlert] =  useState<IAlert>({ show: false, title: '', details: '', variant: 'Danger' });
  const [disableBtn, setDisableBtn] = useState<boolean>(false);
  const [validated, setValidated] = useState(false);
  const [desdeValue, setDesdeValue] = useState('');
  const [hastaValue, setHastaValue] = useState('');
  const storedUserType = localStorage.getItem('user') || '{}';

  const handleSubmit = (event: any) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      downloadData()
    }

  };

  // Descargar polizas
  const downloadData = () => {
    const start = desdeValue.split('-')
    const end = hastaValue.split('-')
    setDisableBtn(true);
  
    const cliCod = JSON.parse(localStorage.getItem('cliCod') || 'null');
    const storedUserTypeParsed = JSON.parse(storedUserType || 'null');
    const isProductor = storedUserTypeParsed?.user?._grupo === "Productor";

    const queryParams: any = { 
      _fechaInicio: `${start[2]}-${start[1]}-${start[0]}`,
      _fechaFin: `${end[2]}-${end[1]}-${end[0]}`,
      _numeroPoliza: mData.numPol
    }
    queryParams[isProductor ? '_codigoProductor' : '_codigoCliente'] = cliCod;
    apiService({
      name: mData.name,
      queryParams,
      onSuccess: (resp) => {
        DownloadDOC(resp, `${mData.docName}_${formatDate(new Date(), '_')}.${mData.docExt}`)
        setDesdeValue('')
        setHastaValue('')
        handleClose()
      },
      onError: (error) => {
        console.error(error)
        setAlert({
          show: true,
          title: mData.errorText || 'Error al generar el reporte.',
          details: error?.message,
          variant: 'Danger'
        })
      },
      onFinally() {
        setDisableBtn(false);
      }
    });
  };

  const resetAlert = () => {
    setAlert(prev => ({ ...prev, show: false }));
  };

  const handleDesdeChange = (event:any) => {
    const newDesdeValue = event.target.value;
    setDesdeValue(newDesdeValue);
    if (!!hastaValue && newDesdeValue > hastaValue) {
      setHastaValue(newDesdeValue);
    }
  };

  const handleHastaChange = (event: any) => {
    setHastaValue(event.target.value);
  };

  return (
    <>
    <Modal
      show={show}
      onHide={()=> {
        setDesdeValue('')
        setHastaValue('')
        handleClose()
      }}
      dialogClassName="modal-md"
      aria-labelledby="modal-generate-report"
    >
      
      <Modal.Header closeButton>
        <Modal.Title>Imprimir reporte</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <section >
          <p>Seleccione un rango de fecha para imprimir los datos.</p>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Form.Group as={Col} md="6" controlId="validationCustom01" className="noFeedback">
                <Form.Label>Fecha inicio <span className="text-danger">•</span></Form.Label>
                <Form.Control
                  required
                  type="date"
                  onChange={handleDesdeChange}
                  value={desdeValue}
                />
                <Form.Control.Feedback type="invalid">Este campo es requerido.</Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="validationCustom02" className="noFeedback">
                <Form.Label>Fecha fin <span className="text-danger">•</span></Form.Label>
                <Form.Control
                  required
                  type="date"
                  min={desdeValue}
                  onChange={handleHastaChange}
                  value={hastaValue}
                />
                <Form.Control.Feedback type="invalid">Este campo es requerido.</Form.Control.Feedback>
              </Form.Group>
            </Row>
            <div className="d-flex justify-content-end border-top">
              <VButton className="primary-bg-btn px-3 py-2 mt-2" type="submit" disabled={disableBtn}>
                <span>{disableBtn && <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>} </span>Descargar
              </VButton>
            </div>
          </Form>
        </section>     
      </Modal.Body>

      <AlertNotification
        show={alert?.show}
        title= {alert?.title}
        details= {alert?.details}
        variant={alert?.variant}
        onClose={resetAlert}
      />

    </Modal>
  </>
  )
}


export default function ModalReports ({ show, handleClose, mData }: IModal) {

  const modalRoot = document.getElementById('modal-root') as HTMLElement;

  return ReactDOM.createPortal(
  <ModalGenerateReport
    show={show} 
    handleClose={handleClose} 
    mData={mData} 
  />, 
  modalRoot)

}


interface IModal{
  show: boolean;
  mData: any;
  handleClose: () => void;
}
